import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { isNil } from 'lodash-es';
import { ME_Fit } from 'me-fit-typings';

@Component({
  selector: 'me-exercise-container',
  templateUrl: './exercise-container.component.html',
  styleUrls: ['./exercise-container.component.css']
})
export class ExerciseContainerComponent implements OnInit {

  @Input() exercise: ME_Fit.Exercise = this.navParams.get('exercise');

  @Input() onCloseClick: Function;

  @Output() onCloseClickEvent = new EventEmitter<void>();


  showCloseButton = false;

  constructor(private modalCtrl: ModalController, public navParams: NavParams) { }

  async ngOnInit() {
    const openModal = await this.modalCtrl.getTop();

    this.showCloseButton = !isNil(openModal)
  }

  close() {
    if (this.onCloseClick) {
      this.onCloseClick();
    }

    this.onCloseClickEvent.emit();
  }

}
